module.exports = __webpack_public_path__ + "img/signUpImage1.4b00dd3a.webp";